<template>
    <b-card header="Carrier Savings Report"
            header-text-variant="white"
            header-bg-variant="info">
        <b-row>
            <b-col lg="3">
                <b-form-group label="From">
                    <date-picker></date-picker>
                </b-form-group>
            </b-col>
            <b-col lg="3">
                <b-form-group label="To">
                    <date-picker></date-picker>
                </b-form-group>
            </b-col>
            <b-col lg="3">
                <b-form-group label="Carrier">
                    <b-form-select :options="carriers"></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div id="savings_chart"></div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6" class="mb-4">
                <h4>Delta in number of hours reported</h4>
                <p>Average number of hours before EVV: 46/week</p>
                <p>Average number of hours After EVV: 38/week</p>
                <span class="text-success">- 8 hours</span>
            </b-col>
            <b-col lg="6" class="mb-4">
                <p>Claims Cost 2018 YTD with EVV: $8,950,100</p>
                <p>Claims Cost 2017 without EVV: $11,445,340</p>
                <p>Savings <span class="text-success">$2,495,240</span></p>
            </b-col>
        </b-row>
    </b-card>
</template>

<style lang="scss">
</style>

<script>
    export default {
        props: ['carriers'],

        mixins: [],

        components: {

        },

        data() {
            return{

            }
        },

        created() {

        },

        mounted() {
            var options = {
                // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
                high: 1000000,
                // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
                low: 0,
                // If specified then the value range determined from minimum to maximum (or low and high) will be divided by this number and ticks will be generated at those division points. The default divisor is 1.
                divisor: 6,
                // If ticks is explicitly set, then the axis will not compute the ticks with the divisor, but directly use the data in ticks to determine at what points on the axis a tick need to be generated.
                ticks: [0, 250000, 500000, 750000, 1000000]
            };

            new Chartist.Line('#savings_chart', {
                options: options,
                labels: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'June',
                    'July',
                    'Aug',
                    'Sept',
                    'Nov',
                    'Dec'
                ],
                series: [
                    [
                        100000,
                        200000,
                        350000,
                        500000,
                        450000,
                        550000,
                        700000,
                        750000,
                        800000,
                        850000,
                        875000,
                        900000
                    ]
                ]
            }, {
                low: 0,
            });
        },

        methods: {

        },

        computed: {

        }
    }
</script>